module.exports = __webpack_public_path__ + "static/media/arcus87.ddcf6681.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/avatars/arcus87.png
// module id = 34
// module chunks = 0